import firebase from "firebase/compat/app";
import { getFunctions, httpsCallable } from "firebase/functions";

const bqExportProgramOnsiteData = async function(programId) {
    const app = firebase.app();
    const functions = getFunctions(app, 'asia-east2');
    const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');

    let prefixFileName = `program-onsite-${programId}-`;
    // let addition = '';
    // if( uid != undefined ){
    //     prefixFileName = prefixFileName + uid;
    //     addition = ` and GM.uid = '${uid}'`;
    // }
    // const downloadUrl = `https://storage.googleapis.com/thaisook_bigquery_export/${prefixFileName}000000000000.csv`;

    const result = await queryThaisookViewBigQuery({
        info: 'get export program onsite data',
        query: `
        EXPORT DATA OPTIONS (
            uri='gs://thaisook_bigquery_export/${prefixFileName}*.csv',
            format='CSV',
            overwrite=true,
            header=true,
            field_delimiter=','
        ) AS (
            with onsite as(
              select 
                U.uid,
                U.firstname,
                U.lastname,
                P.programId,
                P.name,
                CAST(PMO.onsite as string) as onsite,
                PMO.date,
                CAST(PMO.upperPressure as string) as upperPressure,
                CAST(PMO.lowerPressure as string) as lowerPressure,
                CAST(PMO.hr as string) as hr,
                CAST(PMO.weight as string) as weight,
                CAST(PMO.bmi as string) as bmi,
                CAST(PMO.waist as string) as waist,
                CAST(PMO.hip as string) as hip,
                CAST(PMO.whr as string) as whr,
                CAST(PMO.intakeCalories as string) as intakeCalories,
                CAST(PMO.outtakeCalories as string) as outtakeCalories,
                CAST(PMO.sitToStand as string) as sitToStand,
                CAST(PMO.pushUp as string) as pushUp,
                CAST(PMO.walk6MinutesTestDistance as string) as walk6MinutesTestDistance,
                CAST(PMO.walk6MinutesTestVO2Max as string) as walk6MinutesTestVO2Max,
                CAST(PMO.walk6MinutesTestHR as string) as walk6MinutesTestHR,
                CAST(PMO.ymca as string) as ymca,
                CAST(PMO.backScratchRightHandTest as string) as backScratchRightHandTest,
                CAST(PMO.backScratchLeftHandTest as string) as backScratchLeftHandTest,
                CAST(PMO.singleLegBalance as string) as singleLegBalance,
                CAST(PMO.assignment as string) as assignment,
                CAST(PMO.recommendation as string) as recommendation,
                CAST(NULL as string) as sugarTest,
                CAST(NULL as string) as fatTest,
                CAST(NULL as string) as sodiumTest,
                CAST(NULL as string) as vegetableTest,
                CAST(NULL as string) as alcoholTestFreq,
                CAST(NULL as string) as smokeTest,
                CAST(NULL as string) as smokeTestFreq,
                CAST(NULL as string) as stressTest,
                CAST(NULL as string) as perceiveTest,
                CAST(NULL as datetime) as startDate,
                CAST(NULL as datetime) as endDate,
                CAST(NULL as string)   as memberTarget,
                CAST(NULL as string)   as memberPlan,
                CAST(NULL as string)   as programResult,
                CAST(NULL as int)      as totalSteps,
                CAST(NULL as int)      as totalWorkout,
                CAST(NULL as int)      as totalServing,
                CAST(NULL as int)      as totalActivity,
                CAST(NULL as int)      as totalCommunication,
                CAST(NULL as int) as glucose,
                CAST(NULL as int) as hba1c,
                CAST(NULL as int) as cholesterol,
                CAST(NULL as int) as hdl,
                CAST(NULL as int) as ldl,
                CAST(NULL as int) as triglycerides,
                CAST(NULL as int) as creatinine,
                CAST(NULL as int) as eGFR,
                CAST(NULL as int) as uricAcid,
                CAST(NULL as int) as alt_sgpt,
                CAST(NULL as int) as alp,
                CAST(NULL as int) as ast_sgot,
                CAST(NULL as string) as coachName
              from 
                thaisook_view.program_onsite PMO
                join thaisook_view.program_members PM
                  on PMO.programId = PM.programId
                join thaisook_view.users U
                  on PM.uid = U.uid and PMO.uid = PM.uid
                join thaisook_view.program P
                  on PM.programId = P.programId
              where 
                PMO.programId = '${programId}'
              order by PMO.onsite
            ),
              pretest as (
                select 
                  U.uid,
                  U.firstname,
                  U.lastname,
                  P.programId,
                  P.name,
                  'preTest' as onsite,
                  CAST(NULL as datetime) as date,
                  CAST(NULL as string) as upperPressure,
                  CAST(NULL as string) as lowerPressure,
                  CAST(NULL as string) as hr,
                  CAST(NULL as string) as weight,
                  CAST(NULL as string) as bmi,
                  CAST(NULL as string) as waist,
                  CAST(NULL as string) as hip,
                  CAST(NULL as string) as whr,
                  CAST(NULL as string) as intakeCalories,
                  CAST(NULL as string) as outtakeCalories,
                  CAST(NULL as string) as sitToStand,
                  CAST(NULL as string) as pushUp,
                  CAST(NULL as string) as walk6MinutesTestDistance,
                  CAST(NULL as string) as walk6MinutesTestVO2Max,
                  CAST(NULL as string) as walk6MinutesTestHR,
                  CAST(NULL as string) as ymca,
                  CAST(NULL as string) as backScratchRightHandTest,
                  CAST(NULL as string) as backScratchLeftHandTest,
                  CAST(NULL as string) as singleLegBalance,
                  CAST(NULL as string) as assignment,
                  CAST(NULL as string) as recommendation,
                  CAST(PM.preSugarTest as string) as sugarTest,
                  CAST(PM.preFatTest as string) as fatTest,
                  CAST(PM.preSodiumTest as string) as sodiumTest,
                  CAST(PM.preVegetableTest as string) as vegetableTest,
                  CAST(PM.preAlcoholTestFreq as string) as alcoholTestFreq,
                  CAST(PM.preSmokeTest as string) as smokeTest,
                  CAST(PM.preSmokeTestFreq as string) as smokeTestFreq,
                  CAST(PM.preStressTest as string) as stressTest,
                  CAST(PM.prePerceiveTest as string) as perceiveTest,
                  CAST(NULL as datetime) as startDate,
                  CAST(NULL as datetime) as endDate,
                  CAST(NULL as string)   as memberTarget,
                  CAST(NULL as string)   as memberPlan,
                  CAST(NULL as string)   as programResult,
                  CAST(NULL as int)      as totalSteps,
                  CAST(NULL as int)      as totalWorkout,
                  CAST(NULL as int)      as totalServing,
                  CAST(NULL as int)      as totalActivity,
                  CAST(NULL as int)      as totalCommunication,
                  CAST(NULL as int) as glucose,
                  CAST(NULL as int) as hba1c,
                  CAST(NULL as int) as cholesterol,
                  CAST(NULL as int) as hdl,
                  CAST(NULL as int) as ldl,
                  CAST(NULL as int) as triglycerides,
                  CAST(NULL as int) as creatinine,
                  CAST(NULL as int) as eGFR,
                  CAST(NULL as int) as uricAcid,
                  CAST(NULL as int) as alt_sgpt,
                  CAST(NULL as int) as alp,
                  CAST(NULL as int) as ast_sgot,
                  CAST(NULL as string) as coachName
                from 
                  thaisook_view.program_members PM
                  join thaisook_view.users U
                    on PM.uid = U.uid 
                  join thaisook_view.program P
                    on PM.programId = P.programId
                where 
                  PM.programId = '${programId}'
              ),
              posttest as (
                select 
                  U.uid,
                  U.firstname,
                  U.lastname,
                  P.programId,
                  P.name,
                  'postTest' as onsite,
                  CAST(NULL as datetime) as date,
                  CAST(NULL as string) as upperPressure,
                  CAST(NULL as string) as lowerPressure,
                  CAST(NULL as string) as hr,
                  CAST(NULL as string) as weight,
                  CAST(NULL as string) as bmi,
                  CAST(NULL as string) as waist,
                  CAST(NULL as string) as hip,
                  CAST(NULL as string) as whr,
                  CAST(NULL as string) as intakeCalories,
                  CAST(NULL as string) as outtakeCalories,
                  CAST(NULL as string) as sitToStand,
                  CAST(NULL as string) as pushUp,
                  CAST(NULL as string) as walk6MinutesTestDistance,
                  CAST(NULL as string) as walk6MinutesTestVO2Max,
                  CAST(NULL as string) as walk6MinutesTestHR,
                  CAST(NULL as string) as ymca,
                  CAST(NULL as string) as backScratchRightHandTest,
                  CAST(NULL as string) as backScratchLeftHandTest,
                  CAST(NULL as string) as singleLegBalance,
                  CAST(NULL as string) as assignment,
                  CAST(NULL as string) as recommendation,
                  CAST(PM.postSugarTest as string) as sugarTest,
                  CAST(PM.postFatTest as string) as fatTest,
                  CAST(PM.postSodiumTest as string) as sodiumTest,
                  CAST(PM.postVegetableTest as string) as vegetableTest,
                  CAST(PM.postAlcoholTestFreq as string) as alcoholTestFreq,
                  CAST(PM.postSmokeTest as string) as smokeTest,
                  CAST(PM.postSmokeTestFreq as string) as smokeTestFreq,
                  CAST(PM.postStressTest as string) as stressTest,
                  CAST(PM.postPerceiveTest as string) as perceiveTest,
                  CAST(NULL as datetime) as startDate,
                  CAST(NULL as datetime) as endDate,
                  CAST(NULL as string)   as memberTarget,
                  CAST(NULL as string)   as memberPlan,
                  CAST(NULL as string)   as programResult,
                  CAST(NULL as int)      as totalSteps,
                  CAST(NULL as int)      as totalWorkout,
                  CAST(NULL as int)      as totalServing,
                  CAST(NULL as int)      as totalActivity,
                  CAST(NULL as int)      as totalCommunication,
                  CAST(NULL as int) as glucose,
                  CAST(NULL as int) as hba1c,
                  CAST(NULL as int) as cholesterol,
                  CAST(NULL as int) as hdl,
                  CAST(NULL as int) as ldl,
                  CAST(NULL as int) as triglycerides,
                  CAST(NULL as int) as creatinine,
                  CAST(NULL as int) as eGFR,
                  CAST(NULL as int) as uricAcid,
                  CAST(NULL as int) as alt_sgpt,
                  CAST(NULL as int) as alp,
                  CAST(NULL as int) as ast_sgot,
                  CAST(NULL as string) as coachName
                from 
                  thaisook_view.program_members PM
                  join thaisook_view.users U
                    on PM.uid = U.uid 
                  join thaisook_view.program P
                    on PM.programId = P.programId
                where 
                  PM.programId = '${programId}'
              ),
              bloodTestOverview as (
                select 
                  U.uid,
                  U.firstname,
                  U.lastname,
                  P.programId,
                  P.name,
                  'bloodTest' as onsite,
                  HD.date as date,
                  CAST(NULL as string) as upperPressure,
                  CAST(NULL as string) as lowerPressure,
                  CAST(NULL as string) as hr,
                  CAST(NULL as string) as weight,
                  CAST(NULL as string) as bmi,
                  CAST(NULL as string) as waist,
                  CAST(NULL as string) as hip,
                  CAST(NULL as string) as whr,
                  CAST(NULL as string) as intakeCalories,
                  CAST(NULL as string) as outtakeCalories,
                  CAST(NULL as string) as sitToStand,
                  CAST(NULL as string) as pushUp,
                  CAST(NULL as string) as walk6MinutesTestDistance,
                  CAST(NULL as string) as walk6MinutesTestVO2Max,
                  CAST(NULL as string) as walk6MinutesTestHR,
                  CAST(NULL as string) as ymca,
                  CAST(NULL as string) as backScratchRightHandTest,
                  CAST(NULL as string) as backScratchLeftHandTest,
                  CAST(NULL as string) as singleLegBalance,
                  CAST(NULL as string) as assignment,
                  CAST(NULL as string) as recommendation,
                  CAST(NULL as string) as sugarTest,
                  CAST(NULL as string) as fatTest,
                  CAST(NULL as string) as sodiumTest,
                  CAST(NULL as string) as vegetableTest,
                  CAST(NULL as string) as alcoholTestFreq,
                  CAST(NULL as string) as smokeTest,
                  CAST(NULL as string) as smokeTestFreq,
                  CAST(NULL as string) as stressTest,
                  CAST(NULL as string) as perceiveTest,
                  CAST(NULL as datetime) as startDate,
                  CAST(NULL as datetime) as endDate,
                  CAST(NULL as string)   as memberTarget,
                  CAST(NULL as string)   as memberPlan,
                  CAST(NULL as string)   as programResult,
                  CAST(NULL as int)      as totalSteps,
                  CAST(NULL as int)      as totalWorkout,
                  CAST(NULL as int)      as totalServing,
                  CAST(NULL as int)      as totalActivity,
                  CAST(NULL as int)      as totalCommunication,
                  HD.glucose as glucose,
                  HD.hba1c as hba1c,
                  HD.cholesterol as cholesterol,
                  HD.hdl as hdl,
                  HD.ldl as ldl,
                  HD.triglycerides as triglycerides,
                  HD.creatinine as creatinine,
                  HD.eGFR as eGFR,
                  HD.uricAcid as uricAcid,
                  HD.alt_sgpt as alt_sgpt,
                  HD.alp as alp,
                  HD.ast_sgot as ast_sgot,
                  concat(CH.firstname, ' ', CH.lastname) coachName
                from 
                  thaisook_view.program_members PM
                  join thaisook_view.users U
                    on PM.uid = U.uid 
                  join thaisook_view.program P
                    on PM.programId = P.programId
                  join thaisook_view.healthdata HD
                    on HD.uid = PM.uid and HD.source='coach'
                  join thaisook_view.users CH
                    on CH.uid = HD.createdBy
                where 
                  PM.programId = '${programId}'
              ),
              stepsData as (
                SELECT 
                    WO.uid,
                    sum(WO.steps) steps
                FROM 
                    activity_view.steps WO
                    join thaisook_view.program_members G
                        on G.uid = WO.uid 
                where 
                    G.programId = '${programId}'
                    and date(WO.date) between G.startDate and G.endDate
                group by WO.uid
              ),
              workoutData as (
                SELECT 
                    WO.uid,
                    sum(WO.totalWorkout) totalWorkout
                FROM 
                    thaisook_view.program_members G
                    join activity_view.workout WO
                        on G.uid = WO.uid 
                where 
                    G.programId = '${programId}'
                    and date(WO.date) between G.startDate and G.endDate
                group by WO.uid
              ),
              foodData as (
                SELECT 
                    WO.uid,
                    sum(WO.serving) totalServing
                FROM 
                    thaisook_view.program_members G
                    join activity_view.food WO
                        on G.uid = WO.uid 
                where 
                    G.programId = '${programId}'
                    and date(WO.date) between G.startDate and G.endDate
                group by WO.uid
              ),
              dataHealthdata as (
                SELECT 
                    G.uid,
                    count(*) cnt,
                    'healthdata' title
                FROM 
                    thaisook_view.healthdata HD
                    join thaisook_view.program_members G
                    on G.uid = HD.uid 
                where 
                    G.programId = '${programId}'
                    and date(HD.date) between G.startDate and G.endDate
                group by G.uid
            ),
            dataSleep as (
                SELECT 
                    G.uid,
                    count(*) cnt,
                    'sleep' title
                FROM 
                    activity_view.sleep HD
                    join thaisook_view.program_members G
                    on G.uid = HD.uid 
                where 
                    G.programId = '${programId}'
                    and date(HD.date) between G.startDate and G.endDate
                group by G.uid
            ),
            dataWorkout as (
                SELECT 
                    G.uid,
                    count(*) cnt,
                    'workout' title
                FROM 
                    activity_view.workout HD
                    join thaisook_view.program_members G
                    on G.uid = HD.uid 
                where 
                    G.programId = '${programId}'
                    and date(HD.date) between G.startDate and G.endDate
                group by G.uid
            ),
            dataSteps as (
                SELECT 
                    G.uid,
                    count(*) cnt,
                    'steps' title
                FROM 
                    activity_view.steps HD
                    join thaisook_view.program_members G
                    on G.uid = HD.uid 
                where 
                    G.programId = '${programId}'
                    and date(HD.date) between G.startDate and G.endDate
                group by G.uid
            ),
            dataWater as (
                SELECT 
                    G.uid,
                    count(*) cnt,
                    'water' title
                FROM 
                    activity_view.water HD
                    join thaisook_view.program_members G
                    on G.uid = HD.uid 
                where 
                    G.programId = '${programId}'
                    and date(HD.date) between G.startDate and G.endDate
                group by G.uid
            ),
            dataFood as (
                SELECT 
                    G.uid,
                    count(*) cnt,
                    'food' title
                FROM 
                    activity_view.food HD
                    join thaisook_view.program_members G
                    on G.uid = HD.uid 
                where 
                    G.programId = '${programId}'
                    and date(HD.date) between G.startDate and G.endDate
                group by G.uid
            ),
            activityData as (
                select * from dataHealthdata
                union all 
                select * from dataSleep
                union all
                select * from dataWater
                union all
                select * from dataWorkout
                union all
                select * from dataSteps
                union all
                select * from dataFood
            ),
            allActivityData as (
              select uid, sum(cnt) activity from activityData group by uid
            ),
            coachMessage as (
                select 
                    CC.uid,
                    count(1) cnt
                from 
                    activity_view.chat WO 
                    join thaisook_view.program_members CC
                        on WO.messageTo = CC.uid and WO.groupId = CC.groupId
                where 
                    CC.programId = '${programId}'
                    and date(WO.date) between CC.startDate and CC.endDate
                group by CC.uid
            ),
            memberMessage as (
                select 
                    CC.uid,
                    count(1) cnt
                from 
                    activity_view.chat WO 
                    join thaisook_view.program_members CC
                        on WO.messageFrom = CC.uid and WO.groupId = CC.groupId
                where 
                    CC.programId = '${programId}'
                    and date(WO.date) between CC.startDate and CC.endDate
                group by CC.uid
            ),
            allMessage as (
                select uid, cnt from coachMessage
                union all
                select uid, cnt from memberMessage
            ),
            allMessageData as (
              select uid, sum(cnt) message from allMessage group by uid
            ),
            programOverview as (
                select 
                  U.uid,
                  U.firstname,
                  U.lastname,
                  P.programId,
                  P.name,
                  'program' as onsite,
                  CAST(NULL as datetime) as date,
                  CAST(NULL as string) as upperPressure,
                  CAST(NULL as string) as lowerPressure,
                  CAST(NULL as string) as hr,
                  CAST(NULL as string) as weight,
                  CAST(NULL as string) as bmi,
                  CAST(NULL as string) as waist,
                  CAST(NULL as string) as hip,
                  CAST(NULL as string) as whr,
                  CAST(NULL as string) as intakeCalories,
                  CAST(NULL as string) as outtakeCalories,
                  CAST(NULL as string) as sitToStand,
                  CAST(NULL as string) as pushUp,
                  CAST(NULL as string) as walk6MinutesTestDistance,
                  CAST(NULL as string) as walk6MinutesTestVO2Max,
                  CAST(NULL as string) as walk6MinutesTestHR,
                  CAST(NULL as string) as ymca,
                  CAST(NULL as string) as backScratchRightHandTest,
                  CAST(NULL as string) as backScratchLeftHandTest,
                  CAST(NULL as string) as singleLegBalance,
                  CAST(NULL as string) as assignment,
                  CAST(NULL as string) as recommendation,
                  CAST(NULL as string) as sugarTest,
                  CAST(NULL as string) as fatTest,
                  CAST(NULL as string) as sodiumTest,
                  CAST(NULL as string) as vegetableTest,
                  CAST(NULL as string) as alcoholTestFreq,
                  CAST(NULL as string) as smokeTest,
                  CAST(NULL as string) as smokeTestFreq,
                  CAST(NULL as string) as stressTest,
                  CAST(NULL as string) as perceiveTest,
                  PM.startDate     as startDate,
                  PM.endDate       as endDate,
                  PM.memberTarget  as memberTarget,
                  PM.memberPlan    as memberPlan,
                  PM.programResult as programResult,
                  STD.steps        as totalSteps,
                  WOD.totalWorkout as totalWorkout,
                  FD.totalServing  as totalServing,
                  AAD.activity     as totalActivity,
                  AMD.message      as totalCommunication,
                  CAST(NULL as int) as glucose,
                  CAST(NULL as int) as hba1c,
                  CAST(NULL as int) as cholesterol,
                  CAST(NULL as int) as hdl,
                  CAST(NULL as int) as ldl,
                  CAST(NULL as int) as triglycerides,
                  CAST(NULL as int) as creatinine,
                  CAST(NULL as int) as eGFR,
                  CAST(NULL as int) as uricAcid,
                  CAST(NULL as int) as alt_sgpt,
                  CAST(NULL as int) as alp,
                  CAST(NULL as int) as ast_sgot,
                  CAST(NULL as string) as coachName
                from 
                  thaisook_view.program_members PM
                  join thaisook_view.users U
                    on PM.uid = U.uid 
                  join thaisook_view.program P
                    on PM.programId = P.programId
                  join stepsData STD
                    on STD.uid = PM.uid
                  join workoutData WOD
                    on WOD.uid = PM.uid
                  join foodData FD
                    on FD.uid = PM.uid
                  join allActivityData AAD
                    on AAD.uid = PM.uid
                  join allMessageData AMD
                    on AMD.uid = PM.uid
                where 
                  PM.programId = '${programId}'
              ),
              data as (
                select * from onsite
                union all
                select * from pretest
                union all
                select * from posttest
                union all
                select * from bloodTestOverview
                union all
                select * from programOverview
              )
              select * from data 
              order by uid, onsite
        )
    `
    });
    const resultData = JSON.parse(result.data);
    console.log(resultData);
    if (resultData.errors) {
        console.log(resultData.errors);
    }
    else{
        
      for( let i = 0; i < 5; i++ ){
        await wait(3000);
        const isFileExist = await toCheckFile(programId);
        if( isFileExist ){
            return await toDownloadFile(programId);
        }
    }
    }
}


const wait = async (delay) => {
  return new Promise((resolve) => {
      setTimeout(() => {
          resolve();
      }, delay)
  })
}

const toDownloadFile = async (id) => {
  const storage = firebase.app().storage("gs://thaisook_bigquery_export");
  const storageRef = storage.ref();
  const downloadFile = `program-onsite-${id}-000000000000.csv`;

  try {
      // Replace this with your actual file checking logic
      const fileRef = await storageRef.child(downloadFile).getDownloadURL();
      if (fileRef) {
          return fileRef;
      } else {
          return false;
      }
  } catch (error) {
      console.error("Error checking file:", error);
      return false;
  }
}

const toCheckFile = async (id) => {
  const storage = firebase.app().storage("gs://thaisook_bigquery_export");
  const storageRef = storage.ref();
  const checkFile = `program-onsite-${id}-000000000000.bom_added`;

  try {
      // Replace this with your actual file checking logic
      const fileRef = await storageRef.child(checkFile).getDownloadURL();
      if (fileRef) {
          return true;
      } else {
          return false;
      }
  } catch (error) {
      console.error("Error checking file:", error);
      return false;
  }
}
export default bqExportProgramOnsiteData;